(function () {
    'use strict';

    angular
        .module('app')
        .directive('customSelect', customselect);

    customselect.$inject = ['$window', '$filter', '$timeout', '$rootScope', 'uiGridConstants'];


    function customselect($window, $filter, $timeout, $rootScope, uiGridConstants) {
        // Usage:
        //     <customselect></customselect>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/customselect/templates/customselect.html',
            scope: {
                selectedItem: "=?",
                selectedValue: "=?",
                getData: "&",
                items: "=?",
                csDisabled: "=?",
                modelChanged: "=?",
                allowText: "=?",
                selectId: "=?",
                logical: "=?",
                onSubmit: "=?",
                tabIndex: "=?",
                alwaysReload: "=?",
                hasBeenSaved: "=?",
                dirty: "=?",
                resetValue: "=?",
                maxLength: "=?",
                controlObject: "=?",
                backgroundColor: "=?",
                dropdownWidth: "=?",
            }
        };
        return directive;

        function link(scope, element, attrs) {

            var inputChanged = false;
            
            //scope.backgroundColor = 'orange';
            console.log('selectId=' + scope.selectId + ', backgroundcolor=' + scope.backgroundColor);
            var dropdownHeight = 150;
            var callingModelChanged = false;

            //initialize items array
            scope.items = [];

            //used to keep track how many items to render
            scope.itemsRendered = 10

            //get the dropdown element to user for scrolling later.
            var dropdown = $(element).children('#mydropdown');

            var inputChanged = false;

            //store element
            scope.element = element;

            //keep track of the original value
            scope.originalValue;

            //when the input is focused
            scope.inputFocus = function ($event) {
                //console.log("input focused");
                //console.log($event);
                scope.showTable = false;
                //show the clear icon if the input has a value
                scope.showClear = scope.selectedValue != "";

                //show the dropdown
                scope.showToggle();
            }

            //listener for other dropdowns
            $rootScope.$on('dropDownShown', function (event, data) {
                scope.show = false;
            });

            scope.scroll = function () {
                dropdown = $(element.find('#myDropdown'));
                dropdown.scrollTop(dropdown.scrollTop() + dropdownHeight);
            }

            //toggles the dropdown
            scope.showToggle = function () {
                $timeout(function () {
                    //focus
                    if (!scope.show) {
                        var input = $(element.find('input'));

                        //input.focus();
                    }


                    //console.log("Show Toggle");
                    //by default do not show the table
                    scope.showTable = false;

                    //notify other dropdowns to close
                    $rootScope.$broadcast('dropDownShown');
                    selectedIndex = -1;

                    //reset the table values
                    scope.tableValues = [];
                    scope.cachedTableValues = [];

                    //ensure the control is not disabled.
                    if (!scope.csDisabled) {
                        //show the dropdown
                        scope.toggleList();

                        scope.currentItems = scope.items;
                        //get items from the server
                        if (scope.items.length == 0 || scope.alwaysReload) {
                            scope.loading = true;
                            //get items for non logical
                            if (!scope.logical) {
                                scope.getData().then(function (items) {
                                    //related fields
                                    var obj = {};
                                    var item;
                                    var item = items[0] == null ? items[1] : items[0];
                                    if (Object.prototype.toString.call(item) !== '[object String]') {
                                        //extract the info fields
                                        var fieldCount = 0;
                                        dropdownHeight = 250;
                                        scope.showTable = true;

                                        var gridItems = [];
                                        angular.forEach(items, function (item) {
                                            var keys = Object.keys(item);
                                            var gridItem = {};
                                            angular.forEach(keys, function (key) {
                                                gridItem[key.replace('(', '').replace(')', '')] = item[key];
                                            });
                                            gridItems.push(gridItem);
                                        });


                                        scope.gridOptions.data = gridItems;

                                        var columns = generateColumns(items);

                                        scope.gridOptions.columnDefs = columns;

                                        scope.cachedTableValues = angular.copy(gridItems);
                                        var newItems = [];

                                        angular.forEach(gridItems, function (item) {
                                            var key = Object.keys(item);
                                            newItems.push(item[key[0]]);
                                            item.value = item[key[0]];
                                        });
                                        items = newItems;
                                    }

                                    //iterated over the items and create the array of objects
                                    var objItems = [];
                                    angular.forEach(items, function (item) {
                                        objItems.push({ text: item, selected: false });
                                    });

                                    //if the current value is not in the list, add it to the array in case the user wants to go back to
                                    //the original selections
                                    if (scope.selectedValue != "") {
                                        var itemMatches = $filter("filter")(objItems, { text: scope.selectedValue });

                                        if (itemMatches.length == 0) {
                                            objItems.push({ text: scope.selectedValue, selected: false });
                                        }
                                    }

                                    //reorder alphabetically - Bug fix: 
                                    //objItems = $filter("orderBy")(objItems, "text", false);


                                    //set the loading flag to false 
                                    scope.loading = false;
                                    //this variable will contain the original items.
                                    scope.items = angular.copy(objItems);
                                    scope.currentItems = [];

                                    scope.currentItems = objItems;


                                    checkScroll();
                                })
                            }
                            else {
                                scope.loading = false;
                                scope.items = [{ text: "Yes", selected: false }, { text: "No", selected: false }];
                                scope.currentItems = scope.items;
                            }
                        }

                        //cache the items
                        scope.cachedItems = angular.copy(scope.items);
                        angular.forEach(scope.items, function (item, key) {
                            item.selected = false;
                        });
                    }
                    checkScroll();
                });
            }

            function generateColumns(items) {

                if (items.length == 0) {
                    return;
                }

                var columns = [];
                var itemKeys = Object.keys(items[0]);
                var widthMap = [];

                angular.forEach(itemKeys, function (field) {
                    widthMap.push({ field: field, width: '0' });
                });

                angular.forEach(itemKeys, function (field) {
                    var column = {
                        name: field,
                        field: field.replace('(', '').replace(')',''),
                        width: "0",
                    }
                    columns.push(column);
                });

                var charFactor = 10.55;

                var neededWidth = 0;
                //now that we have the columns, figure out their width
                angular.forEach(columns, function (column) {
                    angular.forEach(items, function (item) {
                        var content = item[column.name];
                        //column name length
                        if (parseInt(column.width) < column.name.length * charFactor) {
                            column.width = Math.round((column.name.length * charFactor)).toString();
                        }

                        //content length
                        if (parseInt(column.width) < content.length * charFactor) {
                            column.width = Math.round((content.length * charFactor).toString());
                        }
                    });

                    neededWidth = neededWidth + Number(column.width);
                });

                // if current width is less then needed, then set the dropdown's width to the needed width.
                // Also, make sure it's not too big.
                if (scope.dropdownWidth < neededWidth) {
                    if (neededWidth > 350) {
                        neededWidth = 350;
                    }
                    scope.originalDropDownWidth = scope.dropdownWidth;
                    scope.dropdownWidth = neededWidth;
                }

                return columns;
            }

            scope.toggleList = function () {
                dropdown = $(element.find('#myDropdown'));
                scope.showTable = false;

                $timeout(function () {
                    dropdown.scrollTop(0);
                    //selectedItem = -1;
                }, 100);
                angular.forEach(scope.currentItems, function (item) {
                    item.selected = false;
                });
                $(window).bind('click', function (e) {
                    if (!$(e.target).closest('#' + scope.selectId).length) {
                        scope.inputBlur();
                        scope.dropdownWidth = scope.originalDropDownWidth;
                        scope.show = false;
                        $(window).unbind('click');
                        scope.$apply();
                    }
                });

                if (!scope.show) {
                    scope.show = true;

                    $timeout(function () {
                        //$(window).bind(windowBind);
                        //console.log("BOUND!!!!!");
                        $(window).unbind("keydown").bind("keydown", keyDown);
                    }, 15);
                }
                else {
                    scope.show = false;
                    $timeout(function () {
                        $(window).unbind();
                        //console.log("UNBOUND!!!!!");
                    });
                }
            }

            var checkScroll = function () {
                //on a timeout to allow the items to paint
                $timeout(function () {
                    //get the position of the textbox relative to the card
                    var element = angular.element(scope.element[0]);
                    var elementTopPosition = angular.element(element[0].parentNode).prop('offsetTop');
                    var container = element.parent();

                    //find the parent tab-controls
                    while (!container.hasClass('tab-controls') && !container.hasClass('rf-table')) {
                        container = container.parent();
                        //in case it isn't found
                        if (container.is('body')) {
                            break;
                        }
                    }

                    var parentHeight = container.height();
                    var myDropDown = $("#myDropdown");
                    //if the element's position + 250 is greater than the height of the parent
                    //plus the scroll position then scroll needed
                    if (elementTopPosition + dropdownHeight > parentHeight + container.scrollTop()) {
                        container.scrollTop(container.scrollTop() + (elementTopPosition - (parentHeight + container.scrollTop())) + 250);
                    }
                }, 200);
            }

            //unregister the bind
            var windowBind = function (e) {

            }


            scope.$watch(function () {
                if (scope.selectedValue) {
                    return scope.selectedValue;
                }
            }, function (value) {
                if (scope.logical) {
                    switch ($filter('uppercase')(value)) {
                        case "TRUE":
                        case "T":
                        case "Y":
                        case "YES":
                        case "1":
                            scope.selectedValue = "Yes";
                            break;
                        case "FALSE":
                        case "F":
                        case "N":
                        case "NO":
                        case "0":
                            scope.selectedValue = "No";
                            break;
                    }
                }
            });

            //called when an option is selected from the dropdown
            scope.itemSelected = function(item) {
                console.log("item selected value", scope.selectedValue);

                //hide the dropdown
                scope.show = false;
                //force the clear icon to hide
                scope.showClear = false;
                        
                //update the input's value
                scope.selectedValue = item.text;

                inputChanged = true;

                //$timeout(function () {
                //    itemSelected = false;
                //}, 500);
                
                //fire callback
                notifyModelChanged(scope.selectedValue, scope.selectId, scope.controlObject);

            }

            scope.inputChanged = function () {
                //console.log("input changed");
                inputChanged = true;
                var dropdown = $(element.find('#myDropdown'));
                dropdown.scrollTop(0);
                //show the clear button if the input box has a value.
                scope.showClear = scope.selectedValue != "";

                //filter the items based on the input value
                scope.currentItems = $filter('filter')(scope.items, { text: scope.selectedValue });
                //console.log("input changed");
                //console.log("allowtext:", scope.allowText);
                //if text is not allowed to be entered
                if (!scope.allowText) {
                    if (scope.currentItems.length == 0) {
                        if (scope.selectedValue) {
                            scope.selectedValue = scope.selectedValue = scope.selectedValue.substring(0, scope.selectedValue.length - 1);
                            scope.currentItems = $filter('filter')(scope.items, { text: scope.selectedValue });
                            if (scope.currentItems.length == 0) {
                                scope.selectedValue = scope.originalValue;
                                scope.currentItems = $filter('filter')(scope.items, { text: scope.selectedValue });
                            }
                        }
                    }
                }

                //fire callback to notify of change only if free text is allowed
                if (scope.allowText) {
                    notifyModelChanged(scope.selectedValue, scope.selectId);
                }
                else {
                    notifyModelChanged("++++##filtering##++++", scope.selectId);
                }

                



            }


            //handler for the x to clear icon
            scope.clearSelected = function () {

                //set the selected item to nothing
                scope.selectedValue = "";

                //hide the dropdown
                scope.show = false;

                //hide the clear button
                scope.showClear = false;

                scope.showTable = false;

                //trigger the model changed event
                notifyModelChanged(scope.selectedValue, scope.selectId);


            }


            scope.inputBlur = function () {
                //if the item was clicked, we don't need to execute the following code.
                //console.log("input blured");

                $timeout(function () {
                    //when not allowing custom text
                    if (!scope.allowText && inputChanged) {

       
                        //if the entry has a value, select the first matching value
                        if (scope.selectedValue && scope.selectedValue != "") {

                            var filtered = $filter('filter')(scope.items, function (item) {
                                if (item.text === null) {
                                    inputChanged = false;
                                    return "" == scope.selectedValue.toLowerCase();
                                }
                                inputChanged = false;
                                return item.text.toLowerCase() == scope.selectedValue.toLowerCase();
                            }, true);

                            //var filtered = scope.selectedValue = $filter('filter')(scope.items, { text: scope.selectedValue }, true);
                            if (filtered.length > 0) {
                                scope.selectedValue = filtered[0].text;
                                //notify of change
                                notifyModelChanged(scope.selectedValue, scope.selectId);
                            }
                            else {
                                scope.selectedValue = scope.originalValue;
                            }
                        }

                    }



                    $timeout(function () {
                        //scope.show = false;
                        inputChanged = false;
                        scope.showClear = false;
                    }, 200);

                    if (scope.selectedValue == undefined)
                        scope.selectedValue = "";

                //notifyModelChanged(scope.selectedValue, scope.selectId);


                //console.log("Notified selected value is:", scope.selectedValue);

                }, 250)
            }

            ///////////////////////////
            //// Keyboard Support ////
            /////////////////////////
            var scrolling = false;
            var keyAllowed = true;
            var keyDown = function (e) {
                //slows down execution of keydown handler
                if (keyAllowed && !scrolling) {
                    keyAllowed = false;
                    switch (e.keyCode) {
                        //up
                        case 38:
                            e.preventDefault();
                            if (!scope.showTable) {
                                itemSelectionChanged(-1);
                            }
                            break;
                        //down
                        case 40:
                            e.preventDefault();
                            if (!scope.showTable) {
                                itemSelectionChanged(1);
                            }
                            break;
                        //enter
                        case 13:
                            //hide the dropdown
                            scope.show = false;
                            scope.$apply();
                            break;
                        //tab
                        case 9:
                            scope.show = false;
                            break;
                        default:
                    }
                    $timeout(function () {
                        keyAllowed = true;
                    }, 15);
                }
                else {
                    e.preventDefault();
                }
            }

            scope.$watch(function () {
                return scope.hasBeenSaved;
            }, function () {
                scope.originalValue = scope.selectedValue;
            })

            scope.$watch(function () {
                return scope.resetValue;
            }, function (value) {
                if (value) {
                    scope.originalValue = scope.selectedValue;
                    scope.resetValue = false;
                }
            })

            scope.$watch(function () {
                return scope.show;
            }, function (value) {
                if (value == "") {
                    angular.element($window).off('keydown');
                }
            });

            var selectedIndex = -1;
            var itemSelectionChanged = function (value) {

                //unselect all items
                angular.forEach(scope.currentItems, function (item) {
                    item.selected = false;
                });

                //set the selected index
                selectedIndex = selectedIndex + value;

                //get the popup container
                var dropdown = $(element.find('#myDropdown'));



                //check if the selection is out of bounds
                if (selectedIndex <= -1) {
                    selectedIndex = scope.currentItems.length - 1;
                    //console.log("scrolling to bottom");
                    dropdown.scrollTop(1000000);
                    //set the selected item
                    scope.currentItems[selectedIndex].selected = true;
                    scope.selectedValue = scope.currentItems[selectedIndex].text;
                    notifyModelChanged(scope.selectedValue, scope.selectId);
                    return;
                }
                else if (selectedIndex > scope.currentItems.length - 1) {
                    selectedIndex = 0;
                    //console.log("scrolling to top");
                    dropdown.scrollTop(0);
                    //set the selected item
                    scope.currentItems[selectedIndex].selected = true;
                    scope.selectedValue = scope.currentItems[selectedIndex].text;
                    notifyModelChanged(scope.selectedValue, scope.selectId);
                    return;
                }

                //set the selected item
                scope.currentItems[selectedIndex].selected = true;
                scope.selectedValue = scope.currentItems[selectedIndex].text;
                notifyModelChanged(scope.selectedValue, scope.selectId);
                //apply changes to scope
                scope.$apply(function () {
                    //after scope is updated let it cycle with timeout
                    $timeout(function () {
                        var item = $(dropdown).find(".dropdown-selected");

                        //safeguard in case the selection is not painted
                        if (!item.position()) {
                            dropdown.scrollTop(0);
                            scope.currentItems[0].selected = true;
                            notifyModelChanged(scope.selectedValue, scope.selectId);
                            scope.selectedValue = scope.currentItems[0].text;
                            return;
                        }

                        var scroll = function () {
                            if (value == 1) {
                                //console.log("item top", item.position().top);
                                if (item.position().top > dropdown.height() - 10) {

                                    //console.log("dropdown scroll", dropdown.scrollTop());
                                    //console.log("dropdown height", dropdown.height());
                                    //console.log("item height", item.outerHeight());
                                    var iterations = dropdown.height();
                                    scrolling = true;
                                    dropdown.scrollTop(dropdown.scrollTop() + dropdown.height());
                                    scrolling = false;

                                }
                            }
                            else {
                                //console.log("item top", item.position().top);
                                if (item.position().top < 0) {
                                    var iterations = dropdown.height();
                                    //console.log("top", item.position().top);
                                    scrolling = true;
                                    dropdown.scrollTop(dropdown.scrollTop() - dropdown.height());
                                    scrolling = false;
                                }
                            }
                        }

                        if (item) {
                            scroll();
                        }

                    }, 100);
                })



                //var selectedIndex = -1;
                //dropdown = $(element.find('#myDropdown'));
                //var selectItems = $(dropdown).find(".select-item");

                //var filtered = $filter('filter')(scope.currentItems, { selected: true });
                //if (filtered.length > 0) {
                //    selectedIndex = scope.currentItems.indexOf(filtered[0]);
                //}

                //angular.forEach(scope.currentItems, function (item) {
                //    item.selected = false;
                //});

                //var newSelection = selectedIndex + value;

                //if (newSelection == -2 || newSelection == -1) {
                //    newSelection = 0;
                //    //$(dropdown).scrollTop(1000000);
                //}
                //if (newSelection > scope.currentItems.length - 1) {
                //    newSelection = scope.currentItems.length - 1;
                //    //$(dropdown).scrollTop(0);
                //}

                //var selection = scope.currentItems[newSelection];
                //selection.selected = true;
                //scope.selectedValue = selection.text;
                //scope.$apply(function () {
                //    //trigger the model changed 
                //    //console.log(scope.selectedValue);
                //    scope.modelChanged(scope.selectedValue, scope.selectId);
                //});
                ////scroll
                //$timeout(function () {
                //    var selectedItem = element.find((".dropdown-selected"));
                //    var dropDownHeight = dropdown.height();
                //    var selectedItemheight = $(selectedItem).height();
                //    if (value == 1) {
                //        console.log("Top: " + selectedItem.position().top);
                //        console.log("DropdownHeight: " + dropDownHeight);
                //        console.log("SelecteItem: " + selectedItemheight);
                //        if (Math.round(selectedItem.position().top) > (dropDownHeight - selectedItemheight)) {
                //            var iterations = 10;
                //            dropdown.scrollTop(dropdown.scrollTop() + dropDownHeight);
                //        }
                //    }
                //    else {
                //        if (selectedItem.position().top < 0) {
                //            var iterations = 10;
                //            dropdown.scrollTop(dropdown.scrollTop - dropDownHeight);
                //        }
                //    }

                //});
            }

            //grid
            var gridApi = {};
            scope.gridOptions = {
                enableRowSelection: true,
                data: [],
                enableSorting: false,
                enableColumnMenus: false,
                enableFullRowSelection: true,
                enableRowHeaderSelection: false,
                multiSelect: false,
                onRegisterApi: function (api) {
                    gridApi = api;
                    api.selection.on.rowSelectionChanged(scope, function (row, event) {
                        scope.itemSelected({ text: row.entity['value'], selected: false });
                    });
                },

            }

            var processing = false;
            function notifyModelChanged(value, id, obj) {

                $timeout(function() {
                    processing = false;
                }, 1000);
                if (!processing) {
                    processing = true;
                    console.log("notifyModelChanged", value, id);
                    scope.modelChanged(value, id, obj);
                }
                
            }

        }

        


    }

})();